import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ignore-ope-delete",
  "use": "icon-ignore-ope-delete-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-ignore-ope-delete\"><path d=\"M12.487805 512c0 275.880585 223.63161 499.512195 499.512195 499.512195s499.512195-223.63161 499.512195-499.512195-223.63161-499.512195-499.512195-499.512195-499.512195 223.63161-499.512195 499.512195zM761.756098 474.536585v74.92683H262.243902v-74.92683h499.512196z\" p-id=\"19878\" fill=\"#EB5149\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol